/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_ConjunctionInputs */

const en_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`&`)
};

const ar_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`و`)
};

const bn_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ও`)
};

const de_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und`)
};

const es_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y`)
};

const fr_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`et`)
};

const pt_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e`)
};

const zh_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`&`)
};

const tr_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`&`)
};

const ru_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`&`)
};

const pl_heading_conjunction = /** @type {(inputs: Heading_ConjunctionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`&`)
};

/**
* | output |
* | --- |
* | "&" |
*
* @param {Heading_ConjunctionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_conjunction = /** @type {((inputs?: Heading_ConjunctionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_ConjunctionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_conjunction(inputs)
	if (locale === "bn") return bn_heading_conjunction(inputs)
	if (locale === "de") return de_heading_conjunction(inputs)
	if (locale === "es") return es_heading_conjunction(inputs)
	if (locale === "fr") return fr_heading_conjunction(inputs)
	if (locale === "pt") return pt_heading_conjunction(inputs)
	if (locale === "zh") return zh_heading_conjunction(inputs)
	if (locale === "tr") return tr_heading_conjunction(inputs)
	if (locale === "ru") return ru_heading_conjunction(inputs)
	if (locale === "pl") return pl_heading_conjunction(inputs)
	return en_heading_conjunction(inputs)
});